import PageVisualVerifyEnterprise from "./PageVisualVerifyEnterprise.vue";
const routes = {
  navigation: [
    {
      path: "/visual_verify",
      name: "VisualVerifyEnterprise",
      component: PageVisualVerifyEnterprise,
    },
  ],
};
export default routes;
